import React from 'react';
import PostItem from '../PostItem';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Hit = ({ hit }: { hit: any }) => {
  return (
    <PostItem
      slug={hit.fields.slug}
      image={hit.image}
      title={hit.title}
      date={new Date(hit.date_timestamp * 1000).toLocaleDateString(hit.locale, {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      timeToRead={`${hit.timeToRead}${
        ['-minute read', ' min. de leitura', ' min. di lettura'][
          ['en-US', 'pt-BR', 'it-IT'].indexOf(hit.locale)
        ]
      }`}
      description={hit.description}
      category={hit.category}
      locale={hit.locale}
    />
  );
};

export default Hit;
